import {useEffect, useState} from 'react';
import useSWR from "swr";
import urls from "../api/urls";
import {api} from "../api/apiProvider";
import {HydraData} from "../api/apiProvider";
import {useParams} from "react-router-dom";
import {Engine} from "../api/types";

export function useEngine() {
  const routeParams = useParams();
  const briefId = Number(routeParams.id) || 0;
  const [engineId, setEngineId] = useState(0);
  const [engine, setEngine] = useState<Engine|null>(null);

  const {
    data: brief,
  } = useSWR<HydraData>(briefId > 0 && briefId !== 0 ? `${urls.briefs}/${briefId}?t[]=brief&t[]=brief:engine&t[]=engine` : null, api.get, {
    revalidateOnFocus: false
  });

  useEffect(() => {
    if (brief && brief.data && brief.data.engine && brief.data.engine.id) {
      setEngineId(brief.data.engine.id);
    }
  }, [brief]);

  const {
    data: engineData,
  } = useSWR<HydraData>(engineId > 0 ? `${urls.engines}/${engineId}?t[]=engine&t[]=channel:name&t[]=factor:name&t[]=engine:channels&t[]=engine:factors&t[]=factor` : null, api.get, {
    revalidateOnFocus: false
  });

  useEffect(() => {
    if (engineData && engineData.data) {
      setEngine(engineData.data);
    }
  }, [engineData]);

  return ({
    engine,
  });
}
